/* eslint-disable jira/filename-case */
import type AnalyticsClient from '@atlassiansox/analytics-web-client';
import type {
	AnalyticsEvent,
	AnalyticsWebClient,
	InitAttrs,
	OriginTracingHandlerMapping,
	UIViewedAttributes,
	UnknownEvent,
} from '@jira/platform__observability-product-analytics-web-client-types';

const mockAnalyticsClient: AnalyticsWebClient = {
	init: (_attrs: InitAttrs) => false,
	sendEvent: (_event: AnalyticsEvent | UnknownEvent) => undefined,
	// oxlint-disable-next-line typescript/consistent-type-assertions
	getInstance: () => mockAnalyticsClient as unknown as AnalyticsClient,
	setSubProduct: (_subproduct: string) => undefined,
	setEmbeddedProduct: (_embeddedProduct: string) => undefined,
	clearEmbeddedProduct: () => undefined,
	stopApdexEvent: () => undefined,
	setOriginTracingHandlers: (_originParamHandlerMapping: OriginTracingHandlerMapping) => undefined,
	setUIViewedAttributes: (_attributes: UIViewedAttributes) => undefined,
	removeUIViewedAttribute: (_key: keyof UIViewedAttributes) => undefined,
	clearUIViewedAttributes: () => undefined,
	isInitialized: () => false,
	setUpdateAmplitudeSRClient: () => undefined,
	setAmplitudeSRAttributesInjector: () => undefined,
};

export const getAnalyticsWebClient = (_attrs?: InitAttrs): AnalyticsWebClient =>
	mockAnalyticsClient;
export const initAnalyticsWebClient = (_attrs?: InitAttrs): Promise<AnalyticsWebClient> =>
	Promise.resolve(mockAnalyticsClient);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	ScreenEvent,
	UIEvent,
	TrackEvent,
	OperationalEvent,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	UnknownEvent,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	AnalyticsEvent,
} from '@jira/platform__observability-product-analytics-web-client-types';
